import React from "react";
import AnalyseData from "../assets/full-dw-loop.gif";
import BigData from "../assets/bigCloud.jpg";
import DevLogiciel from "../assets/dash01.jpg";
import Formation from "../assets/formdev.jpg";

const Expertises = ({ id }) => {
  const expertises = [
    {
      title: "Enquête, sondage et  analyse des données",
      image: AnalyseData,
      description:
        "Nos experts sont prêts pour vos projets d'enquête et sondage.Transformez vos données en insights actionnables pour prendre des décisions éclairées.",
      link: "/expertises/analyse-donnees",
    },
    {
      title: "Big Data et cloud computing",
      image: BigData,
      description:
        "Gérez et analysez de grands volumes de données pour en extraire une valeur significative.",
      link: "/expertises/big-data",
    },
    {
      title: "Développement logiciel",
      image: DevLogiciel,
      description:
        "Créez des solutions logicielles sur mesure pour répondre à vos besoins spécifiques.",
      link: "/expertises/developpement-logiciel",
    },
    {
      title: "Formation",
      image: Formation,
      description:
        "Développez les compétences de votre équipe en analyse de données et technologies connexes.",
      link: "/expertises/formation",
    },
  ];

  return (
    <div id={id} className="py-28 p-6 bg-white">
      <h1 className="text-2xl font-bold mb-8 text-center">Nos expertises</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {expertises.map((expertise, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 100}
            className="rounded-lg shadow-lg border border-gray-200 p-4 bg-white"
          >
            <img
              src={expertise.image}
              alt={expertise.title}
              className="w-full h-40 object-cover rounded-t-lg"
            />
            <h3 className="text-lg font-semibold mt-4">{expertise.title}</h3>
            <p className="text-gray-600 mt-2">{expertise.description}</p>
            <a
              href={expertise.link}
              className="inline-block mt-4 px-4 py-2  font-medium rounded bg-[#00171f] text-[#00df9a]  hover:bg-[#2e3432] transition"
            >
              En savoir plus
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Expertises;
